import React, { useContext } from "react";
import { SelectedCardContext } from "../../Context/SelectedCardContext";
import styles from "./About.module.css";
import { Button } from "react-bootstrap";

const ProcurementSupport = () => {
  const { selectedCard, setSelectedCard } = useContext(SelectedCardContext);

  const handleBack = () => {
    setSelectedCard(null);
  };

  const procurementData = [
    "Valves, pipes, flanges & fittings (carbon, stainless, exotic alloys)",
    "Drilling tools & wellhead equipment",
    "Pumps, compressors & separators",
    "Flow meters & instrumentation",
    "Flameproof electronics & cabling",
    "PPE & offshore safety kits",
    "Industrial lubricants & MRO consumables",
  ];

  return (
    <div className={`${styles.procurementSupportSection} ${styles.section7}`}>
      <h2>Procurement support for exploration, drilling, production, and refining operations.</h2>
      {/* <p>{selectedCard.description}</p> */}
      <ul>
        {procurementData.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      {/* <Button onClick={handleBack}>Back</Button> */}
    </div>
  );
};

export default ProcurementSupport;
